import React from 'react';
import $ from 'jquery';
import { render } from 'react-dom';
import App from './components/app';

const title = $('#fs-activity-calendar').data('title');
const subtitle = $('#fs-activity-calendar').data('subtitle');
const property = $('#fs-activity-calendar').data('property');

render(
  <App title={title} subtitle={subtitle} property={property} />,
  document.getElementById('fs-activity-calendar'),
);



// WEBPACK FOOTER //
// ./index.js